import { axios, getDashboardURL } from '@api/shared';

type GetDashboardAppRecentVersionResponse = { version: string };

export const getDashboardAppRecentVersion = () =>
  axios.get<GetDashboardAppRecentVersionResponse>(`${getDashboardURL()}/dashboard/recent-version`);
